import React from "react";
import "../assets/css/HubLoader.css";

interface HubLoaderProps {
  message?: string;
  size?: "small" | "medium" | "large";
  fullScreen?: boolean;
}

const HubLoader: React.FC<HubLoaderProps> = ({
  message = "Loading...",
  size = "medium",
  fullScreen = false,
}) => {
  const content = (
    <div className="hub-loader-content">
      {message && <p className="hub-loader-message">{message}</p>}
      <div className="hub-loader-dots">
        <span className="hub-dot"></span>
        <span className="hub-dot"></span>
        <span className="hub-dot"></span>
      </div>
    </div>
  );

  if (fullScreen) {
    return <div className="hub-loader-overlay">{content}</div>;
  }

  return <div className="hub-loader-inline">{content}</div>;
};

export default HubLoader;
